import { render, staticRenderFns } from "./TeclabCredits.vue?vue&type=template&id=c7c719b0&scoped=true"
import script from "./TeclabCredits.vue?vue&type=script&lang=js"
export * from "./TeclabCredits.vue?vue&type=script&lang=js"
import style0 from "./TeclabCredits.vue?vue&type=style&index=0&id=c7c719b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c719b0",
  null
  
)

export default component.exports